// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"18":"87d5725ad6a940f2","1364":"727973242bb33abd","1702":"ac31ec29fb405eb9","4945":"d0edf7b83c2ee5eb","8482":"97452ebdcfcb513e","8870":"1995843590782737","9026":"52bf97b2d3641561"}[chunkId] + ".css";
};